import { withTranslation } from 'react-i18next';
import React, { Component } from 'react';
import i18next from "i18next";
import Api from "../../../../lib/Api";
import Loader from '../../../Loader';

class SizePosition extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: '',
			position: this.props.position
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.skipBtn = this.skipBtn.bind(this);
		this.goBack = this.goBack.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ position: nextProps.position });
	}

	componentDidMount() {
		window.scrollTo(0, 0);

		this.getData();
		i18next.on('languageChanged', () => { this.getData() })
	}

	render() {
		let handleChange = this.handleChange;
		let selectedPositionId = parseInt(this.state.position, 10);
		if (typeof (this.state.data.data) !== "undefined") {
			var indents = this.state.data.data.map(function (position, i) {
				let checked = selectedPositionId === position.id;
				return (
					<div key={position.id} className={"col-12 option option-" + position.id}>
						<div className="row">
							<div className="col-sm-7" style={{ background: "url(/img/" + position.image + ")" }}>
							</div>
							<div className="col-sm-4 vcenter">
								<div>
									<h3>{position.title}</h3>
									<span>{position.intro}</span>
								</div>
							</div>
							<div className="col-sm-1 vcenter">
								<div>
									<input type="radio" name="experience"
										checked={checked}
										onChange={() => handleChange(position.id)} />
								</div>
							</div>
						</div>
					</div>
				);
			});


			return (


				<form className="row usage" onSubmit={this.handleSubmit}>
					<div className="col-12 text-center title">

						<h2>{this.props.t('position title')}</h2>

					</div>
					{indents}
					<div className="col-6 text-left">
						<button type="button" className="back btn btn-link" onClick={this.goBack}><i
							className="fas fa-caret-left"></i> {this.props.t('Terug naar vorige stap')}
						</button>
					</div>
					<div className="col-6 text-right">
						<button type="button" id="skipbtn" className="btn btn-secondary" onClick={this.skipBtn}>{this.props.t('Sla over')} </button>
						<input id="submitbtn" className="btn btn-secondary" type="submit" value={this.props.t('Volgende')} />
					</div>
				</form>

			);
		} else {
			return <Loader />;
		}

	}

	getData() {
		Api.get('/position', { bike_cat: this.props.traject }).then(response => {
			this.setState({ data: response.data })
		})
	}

	handleChange(value) {
		this.setState({ position: value });
		document.getElementById("submitbtn").disabled = false;
	}

	handleSubmit(event) {
		event.preventDefault();
		if (this.state.position === undefined) {
			alert("please provide an answer");
		} else {
			this.props.handleSubmit(this.state.position);
		}
	}

	goBack(e) {
		e.preventDefault();
		this.props.prevAdviceStep();
	}
	skipBtn(e) {
		e.preventDefault();
		this.props.nextAdviceStep();
	}
}

export default withTranslation('sizesBody')(SizePosition);
